import axios from 'axios';
import config from '../../config';

import tokenApi from './tokenApi';

class CampaignApi {
	static getBaseURL() {
		const apiBase = config.api;
		if (apiBase.includes('localhost') || apiBase.includes('127.0.0.1')) {
			return apiBase;
		}
		return apiBase + '/service/campaign';
	}

	static getInstance() {
		const instance = axios.create({
			baseURL: this.getBaseURL(),
			headers: {
				'Content-Type': 'application/json'
			}
		});

		instance.interceptors.response.use(
			response => response,
			error => {
				if (!error.response || error.response.status === 401) {
					const event = document.createEvent("Event");
					event.initEvent("SessionExpired", true, true);
					document.dispatchEvent(event);
				}
				return Promise.reject(error);
			}
		);

		return instance;
	}
	static get(path) {
		const instance = this.getInstance();
		instance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		return instance.get(path)
			.then(function (response) {
				return response.data;
			})
			.catch(function (error) {
				throw (error);
			});
	}
	static post(path, payload) {
		const instance = this.getInstance();
		instance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		return instance.post(path, payload)
			.then(function (response) {
				return response.data;
			})
			.catch(function (error) {
				throw (error);
			});
	}
	static patch(path, payload) {
		const instance = this.getInstance();
		instance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		return instance.patch(path, payload)
			.then(function (response) {
				return response.data;
			})
			.catch(function (error) {
				throw (error);
			});
	}
	static delete(path, payload) {
		const instance = this.getInstance();
		instance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		return instance.delete(path, payload)
			.then(function (response) {
				return response.data;
			})
			.catch(function (error) {
				throw (error);
			});
	}
}

export default CampaignApi;
